import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AnalyticEvents } from '@app/enums';
import { InterviewQuestion } from '@app/models/recruiting/interview-question.model';
import { Interview } from '@app/models/recruiting/interview.model';
import { JobPosting } from '@app/models/recruiting/job-posting.model';
import { StoreView } from '@app/modules/common/views';
import { AnalyticService, NotifyService } from '@app/services';

@Component({
    templateUrl: './job-posting-interviews-update.template.html',
})
export class JobPostingInterviewsUpdateView extends StoreView {
    interview: Interview;
    jobPosting: JobPosting;
    isLoading = false;

    constructor(
        private route: ActivatedRoute,
        private notify: NotifyService,
        private analyticService: AnalyticService,
        private location: Location
    ) {
        super();
        this.jobPosting = this.route.snapshot.data.models.get('jobPosting');
        this.interview = this.route.snapshot.data.models.get('interview');
    }

    async onSave(): Promise<void> {
        if (!this.interview.interviewQuestions.length) {
            this.notify.error('One interview question is required for an interview');
            return;
        }

        this.isLoading = true;

        try {
            const interview: Interview = await this.interview.save();
            await this.saveInterviewQuestions(interview);
            this.analyticService.trackEvent(
                AnalyticEvents.RecruitingJobPostingInterviewsEditInterviewClickCompleteToSave
            );
            this.notify.success(`Interview ${this.interview.name} has been updated`);
            this.location.back();
        } catch (err) {
            this.notify.error(err || 'Could not save interview');
        }

        this.isLoading = false;
    }

    // TODO: SQE-3688 Discuss potential improvements of moving this to service calling a SAC
    private async saveInterviewQuestions(interview: Interview): Promise<void> {
        await interview.interviewQuestions.forEach(async (interviewQuestion: InterviewQuestion) => {
            interviewQuestion.atsInterviewId = interview.id;
            await interviewQuestion.save();
        });
    }
}
